import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/reports'
export default {
  namespaced: true,
  state: {
    cacheInfo: [],
    loadings: {
      ratingAvg: false,
      diskUsage: false,
      imageCount: false,
      productCount: false,
      categoryCount: false,
      qrCount: false,
      branchCount: false,
      visits: false,
      qrVisits: false,
      mostViewed: false,
    },
    filterParams: {
      sdate: null,
      edate: null,
      id_branches: null,
    },
    dashboard: {
      ratingAvg: {
        flavor_rating: 0,
        service_rating: 0,
        menu_content_rating: 0,
        environment_rating: 0,
        price_rating: 0,
        rating_avg: 0,
      },
      diskUsage: {
        usage: 0,
        limit: 0,
        percent: 0,
      },
      imageCount: 0,
      productCount: 0,
      categoryCount: 0,
      qrCount: 0,
      branchCount: 0,
      visits: {
        singular: 0,
        plural: 0,
      },
      qrVisits: [],
      mostViewed: [],
    },
  },
  getters: {
    dashboard(state) {
      return state.dashboard
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADINGS(state, data) {
      if (data.type === 'ratingAvg') {
        state.loadings.ratingAvg = data.status
      }
      if (data.type === 'diskUsage') {
        state.loadings.diskUsage = data.status
      }
      if (data.type === 'imageCount') {
        state.loadings.imageCount = data.status
      }
      if (data.type === 'productCount') {
        state.loadings.productCount = data.status
      }
      if (data.type === 'categoryCount') {
        state.loadings.categoryCount = data.status
      }
      if (data.type === 'qrCount') {
        state.loadings.qrCount = data.status
      }
      if (data.type === 'branchCount') {
        state.loadings.branchCount = data.status
      }
      if (data.type === 'visits') {
        state.loadings.visits = data.status
      }
      if (data.type === 'qrVisits') {
        state.loadings.qrVisits = data.status
      }
      if (data.type === 'mostViewed') {
        state.loadings.mostViewed = data.status
      }
    },
    SET_DASHBOARD(state, data) {
      if (data.type === 'ratingAvg') {
        state.dashboard.ratingAvg = data.data
      }
      if (data.type === 'diskUsage') {
        state.dashboard.diskUsage = data.data
      }
      if (data.type === 'imageCount') {
        state.dashboard.imageCount = data.data
      }
      if (data.type === 'productCount') {
        state.dashboard.productCount = data.data
      }
      if (data.type === 'categoryCount') {
        state.dashboard.categoryCount = data.data
      }
      if (data.type === 'qrCount') {
        state.dashboard.qrCount = data.data
      }
      if (data.type === 'branchCount') {
        state.dashboard.branchCount = data.data
      }
      if (data.type === 'visits') {
        state.dashboard.visits = data.data
      }
      if (data.type === 'qrVisits') {
        state.dashboard.qrVisits = data.data
      }
      if (data.type === 'mostViewed') {
        state.dashboard.mostViewed = data.data
      }
    },
    RESET_DASHBOARD(state) {
      state.dashboard = {
        ratingAvg: {
          flavor_rating: 0,
          service_rating: 0,
          menu_content_rating: 0,
          environment_rating: 0,
          price_rating: 0,
          rating_avg: 0,
        },
        diskUsage: {
          usage: 0,
          limit: 0,
          percent: 0,
        },
        imageCount: 0,
        productCount: 0,
        categoryCount: 0,
        qrCount: 0,
        branchCount: 0,
        visits: {
          singular: 0,
          plural: 0,
        },
        qrVisits: [],
        mostViewed: [],
      }
    },
    SET_CACHE_INFO(state, data) {
      state.cacheInfo = data
    },
  },
  actions: {
    getDashboard({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      commit('RESET_DASHBOARD', params.type)
      axiosIns
        .post(`${ROOT_URL}?type=${params.type}&noCache=true`, params)
        .then(response => {
          commit('SET_DASHBOARD', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
  },
}
